import { render, staticRenderFns } from "./ElementShowDetailsTab.vue?vue&type=template&id=b40263ce"
import script from "./ElementShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ElementShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports